<template>
  <div>
    <div style="text-align:right;margin-bottom:30px">
      <a-button type="primary" @click="downPdf" style="margin-left:50px">批量下载</a-button>
    </div>

    <a-table :columns="columns" :dataSource="data" bordered :row-selection="rowSelection">
      <template slot="user" slot-scope="text, record, index">
        <a @click="() => goUserDetail(record.user.key)">{{text}}</a>
      </template>

      <template slot="doctor" slot-scope="text, record, index">
        <a @click="() => goDoctor(record.doctor.key)">{{text}}</a>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a @click="() => edit(record.key)" v-if="record.status===2">查看签署</a>
        <a-divider type="vertical" />
        <a
          :href="'https://eic.blueballon.cn'+record.informed_consent.url+'?random_code='+user.random_code"
          target="_blank"
          v-if="record.status===2"
        >下载知情同意书</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import request from "../../utils/request";
const columns = [
  {
    title: "患者",
    dataIndex: "user.name",
    width: "20%",
    scopedSlots: { customRender: "user" }
  },
  {
    title: "手机号",
    dataIndex: "user.phone",
    width: "10%"
  },
  {
    title: "状态",
    dataIndex: "status_text",
    width: "10%"
  },
  {
    title: "对接医生",
    dataIndex: "doctor.name",
    width: "20%",
    scopedSlots: { customRender: "doctor" }
  },
  {
    title: "最后更新时间",
    dataIndex: "update_time",
    width: "20%"
  },
  {
    title: "操作",
    width: "20%",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];

export default {
  data() {
    return {
      data: [],
      columns,
      searchText: "",
      searchInput: null,
      user: JSON.parse(localStorage.getItem("user")),
      selectedRowKeys: []
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        hideDefaultSelections: true,
        onChange: this.onSelectChange,
        onSelection: this.onSelection,
        getCheckboxProps: record => ({
          props: {
            disabled: record.informed_consent.length<=0 || record.status!==2, // Column configuration not to be checked
            name: record.name,
          },
        }),
      };
    }
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    downPdf(item) {
      let selected_list = this.data.filter(item => {
        return this.selectedRowKeys.indexOf(item.key) >= 0;
      });
      if(selected_list.length<1){
        this.$message.error("请选择要下载的文件")
        return
      }
      let str=selected_list.map(item=>{
          return "&ns="+item.user.name+"&acs="+item.informed_consent.auto_code
      })
      let url="https://eic.blueballon.cn/api/v1.0/annex/zip_down?random_code="+this.user.random_code+str.join('')

      console.log("selected_list", selected_list);
      console.log("url", url);
      window.open(url);  

    },
    goUserDetail(key) {
      this.$router.push({ path: "/user/manager/edit", query: { the_id: key } });
    },
    goDoctor(key) {
      this.$router.push({ path: "/doctor/edit", query: { the_id: key } });
    },
    getData() {
      // request({
      //     url: "https://lot.handsomemark.com/mark/",
      //     method: "post",
      //     params: {}
      // }).then(response => {
      //     console.log("测试",response);
      // });

      request({
        url: "/project/people/list",
        method: "get",
        params: {
          project_id: this.$route.query.the_id
        }
      }).then(response => {
        console.log("获取到的参数", response.data.data);
        if (response.data.success) {
          this.data = response.data.data;
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    handleSearch(selectedKeys, confirm) {
      confirm();
      this.searchText = selectedKeys[0];
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    onDelete(key) {
      request({
        url: "/user/" + key + "/",
        method: "delete",
        params: {}
      }).then(response => {
        console.log("111");
        if (response.data.success) {
          this.getData();
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    getBack(key) {
      request({
        url: "/user/getback/" + key,
        method: "put",
        params: {}
      }).then(response => {
        this.getData();
      });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      this.$router.push({ path: "/project/book", query: { the_id: key } });
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter(item => key === item.key)[0];
      const targetCache = newCacheData.filter(item => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter(item => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    }
  }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>